import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/global.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

const whiteList = ['/login', '/wechat/bind']

router.beforeEach((to, from, next) => {
	const token = store.getters.token
	if (token) {
		if (to.path === '/login') {
			next('/dashboard')
		} else {
			// 确保用户信息和权限已加载，否则菜单为空
			if (!store.getters.perms || store.getters.perms.length === 0) {
				store.dispatch('GetInfo').then(() => {
					next()
				}).catch(() => {
					store.dispatch('Logout').then(() => {
						next('/login')
					})
				})
			} else {
				next()
			}
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else {
			next('/login')
		}
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
